import { Link } from "react-router-dom";
import { Facebook, MessageCircle, Send, ShieldCheck } from "lucide-react";
import { ASSETS, NAV_ITEMS, SITE, facebookLink, waLink, telegramLink } from "../lib/site";
import { trackCta } from "../lib/analytics";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/5 bg-[#030303]"
    >
      <div className="shell py-16 grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="flex items-center">
            <img
              src={ASSETS.logo}
              alt="Sloto69"
              width="184"
              height="61"
              className="h-12 w-auto max-w-[184px] object-contain"
            />
          </div>
          <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-md">
            Sloto69 adalah pusat informasi resmi berbahasa Indonesia. Kami menghadirkan panduan,
            artikel edukatif, link alternatif, dan dukungan pengguna dalam satu website company
            profile yang ringan, modern, dan mudah digunakan.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              onClick={() => trackCta("click_whatsapp", "WhatsApp", "footer")}
              className="btn-secondary !py-2 !px-4 text-sm"
            >
              <MessageCircle className="w-4 h-4" /> WhatsApp
            </a>
            <a
              href={telegramLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-telegram"
              onClick={() => trackCta("click_telegram", "Telegram", "footer")}
              className="btn-secondary !py-2 !px-4 text-sm"
            >
              <Send className="w-4 h-4" /> Telegram
            </a>
            <a
              href={facebookLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              onClick={() => trackCta("click_facebook", "Facebook", "footer")}
              className="btn-secondary !py-2 !px-4 text-sm"
            >
              <Facebook className="w-4 h-4" /> Facebook
            </a>
          </div>
        </div>

        <div className="lg:col-span-3">
          <h4 className="text-sm font-semibold tracking-wider uppercase text-[#D4AF37]">
            Menu Cepat
          </h4>
          <ul className="mt-5 grid gap-3 text-sm text-slate-300">
            {NAV_ITEMS.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  data-testid={`footer-link-${item.to.replace(/\//g, "") || "beranda"}`}
                  className="hover:text-white transition"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <h4 className="text-sm font-semibold tracking-wider uppercase text-[#D4AF37]">
            Link Penting
          </h4>
          <ul className="mt-5 grid gap-3 text-sm text-slate-300">
            <li>
              <a
                href={SITE.loginUrl}
                data-testid="footer-login"
                onClick={() => trackCta("click_login", "Login", "footer")}
                className="hover:text-white transition"
              >
                Masuk Sloto69
              </a>
            </li>
            <li>
              <a
                href={SITE.registerUrl}
                data-testid="footer-daftar"
                onClick={() => trackCta("click_daftar", "Daftar", "footer")}
                className="hover:text-white transition"
              >
                Daftar Akun Sloto69
              </a>
            </li>
            <li>
              <Link to="/link-alternatif" data-testid="footer-alt" className="hover:text-white transition">
                Akses Link Resmi / Alternatif
              </Link>
            </li>
            <li>
              <Link to="/keamanan" data-testid="footer-keamanan" className="hover:text-white transition">
                Pusat Keamanan & Edukasi
              </Link>
            </li>
            <li>
              <Link to="/kontak" data-testid="footer-kontak" className="hover:text-white transition">
                Hubungi Tim Bantuan
              </Link>
            </li>
          </ul>

          <div className="mt-6 rounded-xl border border-white/5 bg-white/[0.02] p-4 flex gap-3">
            <ShieldCheck className="w-5 h-5 text-[#10B981] flex-shrink-0 mt-0.5" />
            <p className="text-xs text-slate-400 leading-relaxed">
              Selalu gunakan link resmi, hindari situs tiruan, dan periksa alamat website sebelum
              login. Edukasi keamanan adalah komitmen kami.
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="shell py-6 grid gap-4 md:grid-cols-2 items-center">
          <p className="text-xs text-slate-500 leading-relaxed">
            © {new Date().getFullYear()} {SITE.name}. Seluruh hak cipta dilindungi.
          </p>
          <p className="text-xs text-slate-500 leading-relaxed md:text-right">
            Disclaimer: Website ini dibuat sebagai pusat informasi dan company profile Sloto69.
            Seluruh pengguna diharapkan membaca informasi dengan bijak, menggunakan link resmi,
            dan mengikuti ketentuan yang berlaku di wilayah masing-masing.
          </p>
        </div>
      </div>
    </footer>
  );
}
